/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_CollapseInputs */

const en_case_section_collapse = /** @type {(inputs: Case_Section_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse section`)
};

const pt_br2_case_section_collapse = /** @type {(inputs: Case_Section_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recolher seção`)
};

/**
* | output |
* | --- |
* | "Collapse section" |
*
* @param {Case_Section_CollapseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_collapse = /** @type {((inputs?: Case_Section_CollapseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_CollapseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_collapse(inputs)
	return pt_br2_case_section_collapse(inputs)
});